
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { IconButton } from '@material-ui/core'
import * as transcriptViewerActions from '../../transcriptViewerActions'
import { SendToEmailIcon } from '../../../../components/icons'

import './SendToEmail.scss'

const SendToEmail = ({ transcriptId, trySendToEmail, texts }) => (
  <div className="sendToEmail roundButton" title={texts['send-to-email_title']}>
    <IconButton onClick={() => trySendToEmail(transcriptId)}><SendToEmailIcon /></IconButton>
  </div>
)

SendToEmail.propTypes = {
  transcriptId: PropTypes.string.isRequired,
  trySendToEmail: PropTypes.func.isRequired,
  texts: PropTypes.object.isRequired,
}


export default connect(
  state => ({
    texts: state.app.texts,
  }), dispatch => bindActionCreators({
    trySendToEmail: transcriptViewerActions.trySendToEmail,
  }, dispatch),
)(SendToEmail);
